import { Box, type BoxProps } from '@mantine/core'

export function Bookings({
  children,
  ...props
}: React.PropsWithChildren<BoxProps & React.HTMLAttributes<HTMLDivElement>>) {
  return <Box {...props}>{children}</Box>
}

// Components
export * from './components/ButtonBookingFlectoLinkCopy/ButtonBookingFlectoLinkCopy'
export * from './components/CardBookingQuickDetails/CardBookingQuickDetails'
export * from './components/FiltersBookings/FiltersBookings'
export * from './components/HeaderBookingActions/HeaderBookingActions'
export * from './components/TableBookings/TableBookings'

// Hooks
export * from './hooks/useBookingValues'
export * from './hooks/useBookingPublicLink'
export * from './hooks/useBookingTaxesToggle'

// Pages
export * from './pages/PageBookingsList'
